'use client';
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * При необходимости (задано свойство lines --> asStack === true) вычисляет стили
 * для размещения нескольких строк во flex-контейнере.
 * */ var getStackStyles = function(theme, param) {
    var spacing = param.spacing, asStack = param.asStack, align = param.align;
    if (!asStack) {
        return {};
    }
    var shouldComputeGap = spacing !== 0;
    return _extends({
        display: "flex",
        flexDirection: "column"
    }, align && {
        alignItems: align
    }, {
        width: "100%"
    }, shouldComputeGap && {
        gap: theme.fn.space(spacing != null ? spacing : "1s")
    });
};

export { getStackStyles };
